import { Link } from 'react-router-dom';
import type { Sector } from '../../types/api';
import { Eyebrow, Reveal } from '../ui';

/** « Là où nous intervenons »: grille 3 colonnes, photo puis titre dessous (tous les secteurs qui ont une photo). */
export default function SectorPhotoGrid({ sectors, intro, heading }: { sectors: Sector[]; intro: string; heading: string }) {
  const list = sectors.filter((s) => s.enable && s.cover_image?.url);
  if (list.length === 0) return null;
  return (
    <section className="bg-white py-16 text-black md:py-28">
      <div className="site-container">
        <Eyebrow className="mb-4">Là où nous intervenons</Eyebrow>
        <div className="grid gap-6 lg:grid-cols-2 lg:gap-24">
          <Reveal><h2 className="font-display text-[2rem] font-bold normal-case leading-[1.1] tracking-normal text-black md:text-[2.75rem]">{heading}</h2></Reveal>
          <Reveal delay={0.08}><p className="text-[1.0625rem] leading-relaxed">{intro}</p></Reveal>
        </div>
        <ul className="mt-14 grid gap-x-6 gap-y-14 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((s, i) => (
            <li key={s.id}>
              <Reveal delay={(i % 3) * 0.08}>
                <Link to={`/secteurs/${s.id}`} className="group block">
                  <div className="aspect-video overflow-hidden bg-secondary-200">
                    <img src={s.cover_image!.url} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" />
                  </div>
                  <h3 className="mt-6 font-sans text-[1.25rem] font-semibold normal-case leading-snug tracking-normal text-black transition-colors group-hover:text-brand-darker">{s.name}</h3>
                </Link>
              </Reveal>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
